
//Import React Hooks
import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom' //useParams to get the id transmitted in the url


// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// import created components  :
import Week from '../../components/week/Week.jsx'
import EleveList from '../../components/elevelist/EleveList.jsx'
import CalendarCart from '../../components/calendarcart/CalendarCart.jsx'
import Background from '../../components/background/Background.jsx'
import Comments from '../../components/comments/Comments.jsx'
import EditValidate from '../../components/editvalidate/EditValidate.jsx'
import WallyBanner from '../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { elevesSlice } from "../../store/elevesSlice.js";
import { formulesSlice } from "../../store/formulesSlice.js";
import { selectedCreneauxSlice } from "../../store/selectedCreneauxSlice.js";
import { getSelectedCreneaux, getFormules, getEleves, getFormulesEleves, getCommentaire } from "../../store/selectors.js";
import { resaSlice } from "../../store/resaSlice.js";

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

// config
import { listFidelite, listNiveau } from '../../config/niveau-fidelite-config.js';

//MUI:
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

//Utils
import { checkLogin } from '../../utils/check-login.js'


//// - we get infos from the DB to show editables infos for a Resa ////
function EditResa() { // full page as component imported in router

    const { idResa, idClient } = useParams(); //id of the selected resa, in url (as string)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [allComments, setAllComments] = useState([]);
    const [currentClient, setCurrentClient] = useState();
    const [allInfos, setAllInfos] = useState();
    const [wallyEditor, setWallyEditor] = useState(false);
    const [resaModified, setResaModified] = useState(false);
    const [currentCoupon, setCurrentCoupon] = useState(0);

    const selectedCreneaux = useSelector(getSelectedCreneaux);
    const comment = useSelector(getCommentaire);


    //// -- At first render :
    useEffect(() => {
        async function initFormules() { //we add this inner function to manage asynchrone
            let allFormules = await getFormules(); // get formules from DB ...
            dispatch(formulesSlice.actions.initFormules(allFormules)); //...and send in global state
        } //end of async function
        initFormules(); //call the inner asnchrone function

        async function initResa() { //we add this inner function to manage asynchrone
            let resaInfos = await getResa(); // get resa infos from DB ...
            if (resaInfos.Client.id_client != parseInt(idClient)) {
                navigate("../error")
            }
            //console.log(resaInfos);
            if (resaInfos.match === false) { // we can't modify a resa already matched

                setAllInfos(resaInfos);
                setUpRedux(resaInfos); //... and call the function that will handle them
                setComments(resaInfos); //... and call the function that will handle them
                /// we send all infos of resa, in the global state
                dispatch(resaSlice.actions.setResa(resaInfos));

                setWallyEditor(resaInfos.nb_modifs % 2 === 0);
                setCurrentCoupon(resaInfos.coupon);

            }
            else {
                navigate("../resamatched/" + idResa)
            }
        } //end of async function
        initResa(); //call the inner asnchrone function
    }, [idResa])
    //// --

    //// -- check if login is ok :
    useEffect(() => {


        if (wallyEditor === true && checkLogin() === false) {

            navigate(`/manager/login?dest=editresa/${idResa}/${idClient}`)
        }

    }, [wallyEditor])
    //// --

    //// -- when creneaux are modified :
    useEffect(() => {

        console.log(" modif selectedCreneaux");
        allInfos && compareCreneaux();

    }, [selectedCreneaux])
    //// --


    function compareCreneaux() {
        let identique = true;

        selectedCreneaux.forEach((creneau) => {
            let present = false;
            //we need the number of eleves for each creneau (to compare with modified creneau, same creneau but differents eleves => modified =true)
            let nbElevesDB = allInfos.CreneauEleves.filter((cren) => creneau.creneau.id_creneau === cren.creneau_id).length;

            allInfos.CreneauEleves.map((cren) => {
                if (creneau.creneau.id_creneau === cren.creneau_id) {
                    console.log(nbElevesDB, creneau.eleves)
                    // we compare the number of eleves before/after (present = true if same qty)
                    present = nbElevesDB !== creneau.eleves.length;
                }
            })
            if (present === false) { identique = false; }
        });

        setResaModified(!identique);
        //console.log(identique)

    }

    async function getFormules() { // Get formules from DB
        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/formule`,
            });
            const formules = response.data;
            return formules;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    async function getResa() { // Get Resa Infos from DB (request with joins...)

        try {
            const response = await axios({
                method: 'GET',
                url: baseURL + `/resa/${idResa}`,
            });
            //console.log(response);
            const infos = response.data;
            return infos;
        } catch (err) {
            console.error(err);
            return null;
        }
    }

    //// -- function to handle and show infos from DB, based on id_resa in url/params
    //// -- props "resaInfos" have multiple levels of datas
    function setUpRedux(resaInfos) {
        let allEleves = [];
        let allCreneaux = [];

        resaInfos.CreneauEleves.map((creneauEleve) => { // for every line in CreneauEleve Table...

            //// -- We want to recreate the lists in global state :
            //// -- eleves
            //// -- selectedCreneaux
            //// -- so the calendar will update its display automatically

            // if eleve not in the list already...
            if (allEleves.filter((eleve) => eleve.id === creneauEleve.Eleve.id_eleve).length === 0) {
                allEleves.push({  //... we add this eleve to the list, with his infos reformated for global state "Eleves" 
                    id: creneauEleve.Eleve.id_eleve,
                    prenom: creneauEleve.Eleve.prenom,
                    age: creneauEleve.Eleve.age,
                    /* niveau: listNiveau.find((niveau) => niveau.id === creneauEleve.Eleve.niveau_id).intitule,
                    fidelite: listFidelite.find((fid) => fid.id === creneauEleve.Eleve.fidelite_id).intitule, */
                    niveau: creneauEleve.Eleve.niveau_id,
                    fidelite: creneauEleve.Eleve.fidelite_id,
                    checked: true
                });
                allEleves.sort((e1, e2) => e1.id > e2.id ? 1 : -1); // We sort the list of eleves, as they "arrive" in disorder
            }

            // if creneau not in the list already...
            if (allCreneaux.filter((creneau) => creneau.creneau.id_creneau === creneauEleve.Creneau.id_creneau).length === 0) {
                // we add it to the "local" list...
                allCreneaux.push({ creneau: creneauEleve.Creneau, eleves: [{ id: creneauEleve.Eleve.id_eleve }] })
                // and send it to global state
                dispatch(selectedCreneauxSlice.actions.addCreneau({ creneau: creneauEleve.Creneau, eleves: [{ id: creneauEleve.Eleve.id_eleve }] }));
            }
            else { // creneau is already in the list
                // we isolate the others creneaux :
                let otherCreneaux = allCreneaux.filter((creneau) => creneau.creneau.id_creneau != creneauEleve.Creneau.id_creneau);
                // we isolate the current creneau :
                let thisCreneau = allCreneaux.find((creneau) => creneau.creneau.id_creneau === creneauEleve.Creneau.id_creneau);
                // we get the eleve list from this creneau
                let riderList = thisCreneau.eleves;
                // we add the new eleve from the line in CreneauEleve table (join table)
                riderList = riderList.concat([{ id: creneauEleve.Eleve.id_eleve }]);

                // we reset and refill the list of creneaux:
                allCreneaux.length = 0;
                // other creneau + last modified creneau :
                allCreneaux = otherCreneaux.concat([{ creneau: thisCreneau.creneau, eleves: riderList }])
                // and MODIFY the global state
                dispatch(selectedCreneauxSlice.actions.modifyCreneau({ creneau: creneauEleve.Creneau, eleves: riderList }));
            }


        }); //end of map

        /// we send the list of eleves, for this resa, in the global state
        dispatch(elevesSlice.actions.initEleves(allEleves));


    }

    function setComments(resaInfos) {
        let listComments = [].concat(resaInfos.ResaCommentaires);
        listComments.sort((c1, c2) => dayjs(c1.created).isAfter(dayjs(c2.created) ? -1 : 1));
        //console.log(listComments);
        setAllComments(listComments);
        setCurrentClient(resaInfos.Client)
    }

    const today = dayjs();

    function handleChangeCoupon(montantCoupon) {
        setCurrentCoupon(montantCoupon);
        dispatch(resaSlice.actions.modifCouponResa(montantCoupon));
    }

    async function handleMatch() { // modify (if necessary) coupon and commentaire before confirm match

        let respCoupon = await modifCoupon(currentCoupon);
        let respComment = await insertCommentaire();

        //console.log(respComment, respCoupon);
        if (respCoupon >= 200 && respComment >= 200) {

            navigate(`../matchresa/${allInfos.id_resa}/${allInfos.Client.id_client}`);
        }

    }

    async function modifCoupon(coupon) {

        if (coupon !== allInfos.coupon) {

            try {
                const response = await axios({
                    method: 'PUT',
                    url: `${baseURL}/resa/${allInfos.id_resa}`,
                    data: {
                        coupon: coupon
                    }
                });
                return response.status;
            } catch (err) {
                return 0;
            }

        }
        else {
            return 300;
        }


    }

    async function insertCommentaire() {
        if (comment.length > 0) { // commentaire présent

            try {
                const response = await axios({
                    method: 'POST',
                    url: `${baseURL}/resa-commentaire`,
                    data: {
                        commentaire: comment,
                        by_client: allInfos.nb_modifs % 2 > 0,
                        resa_id: allInfos.id_resa // and IMPORTANT resa id
                    }
                });
                return response.status;
            } catch (err) {
                return 0;
            }

        }
        else {
            return 300;
        }


    }




    return (
        <div className="bg-relative">
            <Background ind={2} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner />
                    <EleveList />
                    {wallyEditor === true ?
                        <div className="calendar-coupon">
                            <div className="calendar-coupon-infos">
                                <p className="calendar-coupon-infos-label">Type de coupon (en %):</p>
                                <Select
                                    className="calendar-coupon-infos-select"
                                    size="small"
                                    value={currentCoupon}
                                    label="horaire"
                                    onChange={e => handleChangeCoupon(e.target.value)}
                                >
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={5}>5</MenuItem>
                                    <MenuItem value={10}>10</MenuItem>
                                    <MenuItem value={15}>15</MenuItem>
                                    <MenuItem value={20}>20</MenuItem>
                                    <MenuItem value={25}>25</MenuItem>
                                    <MenuItem value={30}>30</MenuItem>
                                </Select>
                            </div>
                        </div>
                        : null}

                    <CalendarCart />

                    {resaModified === true ?
                        <EditValidate />
                        :
                        <Button
                            className="bottom-nav-next-match"
                            onClick={_ => handleMatch()}
                            variant="contained">
                            Matchez ces sessions <CheckIcon />
                        </Button>
                    }

                    <Week date={today} manager={false} />

                    <Comments readOnly={false} comList={allComments} client={currentClient} />

                </div>
            </main>
        </div>
    );
}

export default EditResa;